// extracted by mini-css-extract-plugin
export default {"error":"LoginError_error__pFMhf"};